module.exports = __webpack_public_path__ + "static/img/activityrules.3538b686.svg";